import { render, staticRenderFns } from "./DropdownInputValueItem.vue?vue&type=template&id=62a71c35&scoped=true"
import script from "./DropdownInputValueItem.vue?vue&type=script&lang=ts"
export * from "./DropdownInputValueItem.vue?vue&type=script&lang=ts"
import style0 from "./DropdownInputValueItem.vue?vue&type=style&index=0&id=62a71c35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a71c35",
  null
  
)

export default component.exports